  const SignalProvider = {
      // Signals define a transition between states.
      // In angular, this allows for communication between: Parent / child scopes. Sibling scopes.
      Auth: {
          AccessTokenUpdated: 'AccessTokenUpdated'
      },
      Approval: {
          newApproval: {
            approvalResourceUpdated: 'newApproval.approvalResourceUpdated',
            approvalLevelConfigUpdated: 'newApproval.approvalLevelConfigUpdated',
            approvalApproverUpdated: 'newApproval.approvalApproverUpdated'
          },
          view: {
            updateApprovalRequest: 'view.updateApprovalRequest'
          }
      },
      ActivityFeed: {
          FilterByInitiatorActor : 'FilterByInitiatorActor',
          FilterByTargetActor : 'FilterByTargetActor',
          FilterByCommentRecipient : 'FilterByCommentRecipient'
      },
      DateTime: {
          ClearMemoizedDates: 'dateTimeClearMemoizedDates'
      },
      CustomClickEvent : 'SignalProvider.CustomClickEvent',
      WorkDocsCompanion: {
          ConnectionEstablished: 'ConnectionEstablished'
      },
      Task: {
        AccessRequestCreated: 'Task.AccessRequestCreated'
      },
      Document: {
          Loaded: 'DocumentLoaded',
          StartDragging: 'startDragging',
          StopDragging: 'stopDragging',
          ActivityLoaded: 'activityLoaded',
          Uploaded: 'DocumentUploaded',
          fileUploadStatusChange: 'fileUploadStatusChanged',
          fileUploadFailed: 'fileUploadFailed'
      },
      Folder: {
          HighlightResource : 'Folder.HighlightResource',
          RequestSyncView: 'folderRequestSyncView',
          SyncCurrentView: 'folderSyncCurrentView',
          NotSyncCurrentView: 'notSyncCurrentView'
      },
      ShareLink: {
          Created: 'ShareLink.Created',
          Deleted: 'ShareLink.Deleted'
      },
      Selection: {
          SelectionUpdated: 'Selection.SelectionUpdated',
          TaskSelected: 'Selection.TaskSelected',
          TaskUnselected: 'Selection.TaskUnselected',
          TaskSelectedAll: 'Selection.TaskSelectedAll',
          TaskUnselectedAll: 'Selection.TaskUnselectedAll'
      },
      ResourceSelectionComponent: {
          SelectionUpdated: 'ResourceSelectionComponent.SelectionUpdated'
      },
      Feedback: {
          // Transitions
          // Feedback -> Feedback drawn that elements are ready to render
          Loaded: 'FeedbackDirectiveLoadedDone',

          // Action
          TextCopyStart: 'feedbackStartTextSelection',
          TextCopyClear: 'feedbackClearTextSelection',
          UpdateMetadata: 'feedbackUpdateMetadata',
          Refresh: 'feedbackRefresh',
          ScrollToFeedbackPage: 'feedbackPageScroll',
          Deselect: 'feedbackDeselect',
          Selected: 'feedbackSelected',
          SelectWord: 'feedbackSelectWord',
          ClearFeedbackFilter: 'clearFeedbackFilter',
          UpdateFeedbackCount: 'updateFeedbackCount',

          SwitchUser: 'switchUser',
          Cancel: 'cancel'
      },
      FeedbackDrawn: {
          //New Signals
          FeedbackPanelScrolled: 'FeedbackPanelScrolled',
          // Actions
          AllFeedbackRendered : 'allFeedbackRendered'
      },
      FeedbackInput: {
          QueuedAnnotation: 'queudAnnotation',
          QueuedComment: 'queuedComment',
          Hide: 'hideFeedbackInput',
          Clear: 'clearFeedback',
          InsertText: 'insertText',
          HIDE_DRAFT_PUBLISHING_TEXTFIELD_WITH_NO_TEXT : 'HIDE_DRAFT_PUBLISHING_TEXTFIELD_WITH_NO_TEXT',
          OVERALL_FEEDBACK_IN_FOCUS : 'OVERALL_FEEDBACK_IN_FOCUS'
      },
      Edit: {
          CheckEditServer: 'checkEditServer'
      },
      People: {
          Selected: 'SelectedPerson',
          AddedShare: 'addedShare',
          RemovedShare: 'removedShare',
          CountUpdated: 'PeopleSidebarCountUpdated'
      },
      Group: {
          ClearExpandingGroup: 'clearExpandingGroup'
      },
      Profile: {
          PhotoUpdated: 'ProfilePhotoUpdated',
          UpdatePhotoUploadUrl: 'UpdatePhotoUploadUrl'
      },
      PDF: {
          GetUnderlays: 'getUnderlays',
          GetUnderlaysAndRefreshFeedback: 'getUnderlaysAndRefreshFeedback',
          ScheduleUpdate: 'scheduleUpdate',
          SelectVersionAndPage: 'selectVersionAndPage',
          PDFViewResetAnnotation: 'PDFViewResetAnnotation',
          ToolbarGrow: 'PDFViewToolbarGrow',
          ToolbarShrink: 'PDFViewToolbarShink'
      },
      Sidebar: {
          ChangeRight: 'SidebarChangeSlide',
          HideLeft: 'SidebarHideLeft',
          HideRight: 'SidebarHideRight',
          ShowLeft: 'SidebarShowLeft',
          ShowRight: 'SidebarShowRight',
          SlideRight: 'SidebarRightSlide',
          ToggleLeft: 'SidebarToggleLeft',
          ToggleRight: 'SidebarToggleRight',
          UpdateCounts: 'SidebarUpdateCounts',
          EmptyRecycleBin: 'EmptyRecycleBin',
          FocusFeedbackInput: 'FocusFeedbackInput',
          HideAnnotationArrow: 'HideAnnotationArrow'
      },
      Scroll: {
          Enabled: 'scrollEnabled',
          Stopped: 'scrollingStop',
          LoadMoreVersionTiles: 'closeToEndVersionSwitcherTiles',
          LoadMoreVersionComments: 'closeToEndVersionComments',
          Update: 'ScrollRefreshRefresh',
          Up: 'ScrollUp',
          Down: 'ScrollDown'
      },
      ContentLoading: {
          LoadMore: 'ContentLoading.loadmore',
          Done: 'ContentLoading.done',
          Start: 'ContentLoading.start'
      },
      Window: {
          ActivePanel: 'ActivePanel',
          CloseModals: 'WindowCloseModals',
          Resized: 'WindowResized'
      },
      InfoBox: {
          ShowEditWithLockModal: 'InfoBox.ShowEditWithLockModal'
      },
      Permission: {
          PermissionUpdated: 'Permission.PermissionUpdated',
          PrincipalRemoved: 'Permission.PrincipalRemoved'
      },
      Search: {
          HideSearchMenu: 'Search.HideSearchMenu',
      },
      FeatureNotification:{
          RegisterNotification: 'FeatureNotification.RegisterNotification'
      }
  };

  angular.module('GorillaBoy.common')
  .constant('SignalProvider', SignalProvider);

export default SignalProvider;
